import { Injectable, ComponentRef, Injector, ApplicationRef, createComponent } from '@angular/core';
import { Observable } from 'rxjs';
import { EmailComposerComponent } from '../custom-modules/util-module/email-composer/email-composer.component';
import { EmailComposerOptions, EmailComposerResult } from '@interfaces';

@Injectable({ providedIn: 'root' })
export class EmailService {
  private ref: ComponentRef<EmailComposerComponent> | null = null;

  constructor(private appRef: ApplicationRef, private injector: Injector) { }

  open(options: EmailComposerOptions): Observable<EmailComposerResult> {
    // create component
    this.ref = createComponent(EmailComposerComponent, {
      environmentInjector: this.appRef.injector,
      elementInjector: this.injector
    });

    const instance = this.ref.instance;

    this.appRef.attachView(this.ref.hostView);
    document.body.appendChild(this.ref.location.nativeElement);

    // open + init
    Promise.resolve(instance.openComposer(options));

    // return observable
    const closed$ = instance.closed.asObservable();
    closed$.subscribe(() => this.close());

    return closed$;
  }

  close() {
    if (!this.ref) return;
    this.appRef.detachView(this.ref.hostView);
    this.ref.destroy();
    this.ref = null;
  }
}
